module.exports = __webpack_public_path__ + "static/media/Icon awesome-phone-alt.457cda09.svg";